module.exports = __webpack_public_path__ + "img/working_typeface.4e0d2a8d.jpg";